/**
 * «چند ثانیه روی صفحه‌ی این رخداد ماند» (WHOSUP-297) — قرینه‌ی
 * apps/mobile/src/features/discover/useItemDwell.ts.
 *
 * فقط زمانی که تب جلوی چشم است شمرده می‌شود (نگاه کن به `makeDwellTimer`)؛
 * با رفتن به صفحه‌ی دیگر یا رخدادِ دیگر ثبت می‌شود. بستنِ کاملِ تب ثبت
 * نمی‌شود — همان لحظه `session_end` مدتِ همین صفحه را دارد.
 */
import React from 'react';
import { trackItemDwell } from '@/core/lib/analytics';
import { makeDwellTimer } from '@/core/lib/itemWatch';

export function useItemDwell(kind: 'event' | 'place', id: string | null | undefined): void {
  React.useEffect(() => {
    if (!id) return;
    const timer = makeDwellTimer(Date.now());
    if (document.visibilityState === 'hidden') timer.pause(Date.now());
    const onVis = () => {
      if (document.visibilityState === 'hidden') timer.pause(Date.now());
      else timer.resume(Date.now());
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      document.removeEventListener('visibilitychange', onVis);
      trackItemDwell(kind, id, timer.elapsed(Date.now()));
    };
  }, [kind, id]);
}
